import { render, staticRenderFns } from "./trend-collection-icon.vue?vue&type=template&id=13401589"
import script from "./trend-collection-icon.vue?vue&type=script&lang=js"
export * from "./trend-collection-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports